import { useLocation } from "react-router-dom";
import Chatbox from '../../features/chatbox/components/Chatbox';

import ChatboxContextProvider from '../../features/chatbox/context/ChatboxContext'
import BotUserContextProvider from '../../features/chatbox/context/ConversationContext';
import '../../features/chatbox/App.css';
import { env } from '../../var/env';

function BotTest() {

    const location = useLocation();
    var info = location.pathname.split('/').pop();
    
    var [name, bot, channelKey] = info.split('-');

    const backEndOrigin = new URL(env.REACT_APP_API_PATH).origin;
    const variables = Object.fromEntries(new URLSearchParams(window.location.search));
    const configChatbox = { bot, company: name, backEndService: backEndOrigin, mode: 'test', defaultValues: { variables },channelKey}

    return (
        <>
            <BotUserContextProvider config={configChatbox}>
                <ChatboxContextProvider>
                    <Chatbox />
                </ChatboxContextProvider>
            </BotUserContextProvider>
        </>
    );
}
export default BotTest;